import { Timezone } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export async function connectCalendar(
  userId: string,
  data: {
    timezone: Timezone;
  }
): Promise<{ data?: { accessToken: string }; success: boolean }> {
  const res = await fetcher(`user/${userId}/calendar`, {
    method: 'POST',
    body: {
      ...data,
    },
  });

  if (!res.ok) {
    return {
      success: false,
    };
  }

  const response = await res.json();

  return {
    success: true,
    data: {
      accessToken: response.accessToken,
    },
  };
}
